<template>
    <div>
        <PointInfoAccount v-if="isLoginAccount"></PointInfoAccount>
        <PointInfoGuest v-else></PointInfoGuest>
    </div>
</template>
<script>
import AuthStatusMixin from '@/mixin/AuthStatusMixin'
import PointInfoAccount from './component/PointInfoAccount.vue'
import PointInfoGuest from './component/PointInfoGuest.vue'

export default {
    mixins: [AuthStatusMixin],
    components: {
        PointInfoAccount,
        PointInfoGuest,
    },
}
</script>
<style lang="scss" scoped>
</style>
